import randomNum from "../helpers/randomNum";

export default function maxSpin(rows, spin) {
  switch (rows) {
    case 8:
      return spin > 6 ? 6 : spin;
    case 9:
      return spin > 6 ? 6 : spin;
    case 10:
      return spin > 5.5 ? 5.5 : spin;
    case 11:
      spin = randomNum(30, 55) / 10;
      return spin;
    case 12:
      spin = randomNum(25, 50) / 10;
      return spin;
    case 13:
      spin = randomNum(20, 45) / 10;
      return spin;
    case 14:
      spin = randomNum(20, 40) / 10;
      return spin;
    case 15:
      spin = randomNum(10, 35) / 10;
      return spin;
    case 16:
      // if (spin > 3.5) return 3.5;
      spin = randomNum(10, 35) / 10;
      return spin;

    default:
      break;
  }
}
